module.exports = __webpack_public_path__ + "fonts/FSSinclair-BoldItalic.6057051c.otf";